// @flow

import React from 'react';

import { BadgeName } from '@app/components/badges/badge-name';
import { T } from '@app/components/translation';

import { RemoveConfirm } from '../remove-confirm';

export type Props = {
  dataField: DataField,
  removeState: RemoveState,
  resetRemoveState: Function,
  removeDataField: () => void,
  children: Function,
};

export const handleConfirm = (removeDataField: Function, isLoading: boolean) => () => {
  if (isLoading) {
    return;
  }

  removeDataField();
};

export const RemoveDataFieldConfirmation = ({
  removeState,
  removeDataField,
  dataField,
  children,
  resetRemoveState,
}: Props) => (
  <RemoveConfirm
    onConfirm={removeDataField}
    confirmState={removeState}
    resetConfirmState={resetRemoveState}
    confirmMessage={(
      <T
        _str="You are about to delete {name}. This action can't be undone."
        name={<BadgeName>{dataField.name}</BadgeName>}
        _comment="Modal text when deleting a data field."
      />
      )}
    modalKey="delete data field modal"
  >
    {children}
  </RemoveConfirm>
);
